import { render } from "./TacticalBoardCanvas.vue?vue&type=template&id=d9b67f3e&scoped=true"
import script from "./TacticalBoardCanvas.vue?vue&type=script&lang=js"
export * from "./TacticalBoardCanvas.vue?vue&type=script&lang=js"

import "./TacticalBoardCanvas.vue?vue&type=style&index=0&id=d9b67f3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b67f3e"]])

export default __exports__